import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: theme?.palette?.lightBackground?.main,
    borderRadius: 4,
  },
  iconWrapper: {
    padding: '15px',
    width: 'max-content',
  },
  icon: {
    height: '24px',
    width: '24px',
  },
  contentWrapper: {
    flex: 1,
  },
  questionWrapper: {
    padding: '15px 40px 12.5px 0px',
    borderBottom: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  question: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '22px',
    fontSize: '16px',
    '& > *': {
      overflowWrap: 'break-word',
      msWordBreak: 'break-all',
      wordBreak: 'break-word',
      msHyphens: 'auto',
      MozHyphens: 'auto',
      WebkitHyphens: 'auto',
      hyphens: 'auto',
      whiteSpace: 'pre-wrap',
      margin: 0,
      padding: 0,
      listStylePosition: 'inside',
    },
    '& > * > img': {
      maxHeight: '100%',
      maxWidth: '100%',
    },
    '& > pre': {
      background: 'black',
      color: 'white',
      padding: '5px',
    },
  },
  resultWrapper: {
    flex: 1,
  },
  testCasesPassedAndViewAllTheTestcaseDetailsWrapper: {
    width: '50%',
    borderRight: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  testCasesPassedWrapper: {
    flex: 1,
    padding: '15.5px 10px 15.5px 0px',
  },
  testCasesPassedHeading: {
    fontSize: '12px',
    color: theme?.palette?.resultsPageLightTextColor?.main,
    marginBottom: '4px',
  },
  testCasesPassed: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
  },
  viewAllTheTestcaseDetailsWrapper: {
    paddingRight: '15px',
  },
  viewAllTheTestcaseDetails: {
    fontWeight: 600,
    color: theme?.palette?.primarySelection?.main,
    fontSize: '12px',
    padding: 0,
    backgroundColor: 'white',
    '&:hover': {
      color: 'white',
    },
  },

  languageAndViewCodeWrapper: {
    width: '50%',
  },
  languageWrapper: {
    flex: 1,
    padding: '15.5px 10px 15.5px 40px',
  },
  languageHeading: {
    fontSize: '12px',
    color: theme?.palette?.resultsPageLightTextColor?.main,
    marginBottom: '4px',
  },
  language: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
  },
  viewCodeWrapper: {
    paddingRight: '15px',
  },
  viewCode: {
    fontWeight: 600,
    color: theme?.palette?.primarySelection?.main,
    fontSize: '12px',
    padding: 0,
    backgroundColor: 'white',
    '&:disabled': {
      color: theme?.palette?.primarySelection?.disabled,
    },
    '&:hover': {
      color: 'white',
    },
  },

  marksContainer: {
    padding: '10px',
    width: 'max-content',
    borderLeft: `solid 1px ${theme?.palette?.lightDividerLines?.main}`,
  },
  marksWrapper: {
    background: theme?.palette?.darkBackground?.main,
    height: '100%',
    minWidth: '73px',
    minHeight: '108px',
    borderRadius: 4,
    padding: '20px',
  },
  marks: {
    overflowWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-word',
    msHyphens: 'auto',
    MozHyphens: 'auto',
    WebkitHyphens: 'auto',
    hyphens: 'auto',
    whiteSpace: 'pre-wrap',
    lineHeight: '19px',
    fontWeight: 600,
  },
  marksHeading: {
    fontSize: '12px',
  },
  allTestCaseDialog: {
    padding: 0,
  },
  allTestCaseDialogButton: {
    width: '100%',
  },
  testCaseDisplay: {
    fontSize: '22px',
    height: '26px',
    fontWeight: 700,
    wordBreak: 'break-word',
    color: '#202020',
    paddingLeft: '40px',
  },
  sampleAndNormalTestCase: {
    padding: '0 40px',
    margin: '40px 0',
  },
  sampleAndNormalTestCaseDisplay: {
    marginBottom: '20px',
  },
  codeHeader: {
    fontSize: '22px',
    height: '26px',
    fontWeight: 700,
    wordBreak: 'break-word',
    color: '#202020',
    paddingLeft: '20px',
  },
  codeEditor: {
    marginTop: '20px',
    padding: 0,
  },
}))

export { useStyles }
